import { useSelector } from 'react-redux';
import { getDateWithSpecificFormat } from '../../../../data-transform';
import { getStatusDescriptionFromStatusValue, getCountryNameByCountryCode, getOrderTypeText } from '../../../../../utils/utility';

const constructOrderStatusOptions = (orderStatus, orderType) => {
    let orderStatusOptions = [{ id: orderStatus, label: getStatusDescriptionFromStatusValue(orderStatus) }]
    if ((orderStatus === 'ORDER_RECEIVED' || orderStatus === 'ORDER_SENT' || orderStatus === 'ORDER_SUBMITTED') && orderType === "1") {
        orderStatusOptions.push({ id: "ASSETS_COLLECTED", label: "Assets Collected" });
    }
    else if (((orderStatus === 'ORDER_RECEIVED' || orderStatus === 'ORDER_SENT' || orderStatus === 'ORDER_SUBMITTED') && orderType === "2") || orderStatus === 'ASSETS_COLLECTED' && orderType === "1") {
        orderStatusOptions.push({ id: "ASSETS_RECEIVED", label: "Assets Received" });
    }
    return orderStatusOptions;
}

export default function DirectCustomerOrderDetailColumnsSpecification(config) {
    const { userProfile } = useSelector(state => state);
    const { customerType, userType } = userProfile;
    if (!config.data) return null;

    let result = {};
    let tableData = [];

    config.data.forEach((order) => {
        let row = [];
        const rowId = order.orderId;
        config.columns.forEach(column => {
            const columnId = column.id;
            const displayAsIs = column.data.displayInBodyAsIs;
            let columnDataType = column.data.displayInBodyAs;
            const highlightColumn = column.data.highlightBodyText;

            let columnValue = null;
            let columnValueData = null;
            let isDisabled = false;

            if (columnDataType === "string") {
                if (columnId === "orderId" && order.orderId) {
                    columnValue = order.orderId;
                }
                if (columnId === "vendorOrderId") {
                    columnValue = order.vendorOrderId || "";
                }
                else if (columnId === "creationDate") {
                    columnValue = getDateWithSpecificFormat(order.createdDate) || "";
                }
                else if (columnId === "orderType") {
                    columnValue = getOrderTypeText(order.orderType) || "";
                }
                else if (columnId === "country") {
                    columnValue = order.countryCode ? getCountryNameByCountryCode(order.countryCode) : "";
                }
                else if (columnId === "totalAssetsQuoted") {
                    columnValue = order.qtyAssetsQuoted || "";
                }
                else if (columnId === "totalAssetsCollected") {
                    columnValue = order.qtyAssetsCollected || "";
                }
                else if (columnId === "currency") {
                    columnValue = order.currencyCode || "";
                }
                else if (columnId === "quotedNetValue") {
                    if(order.customerType === "indirect") {
                        isDisabled = order.totalNetValue === null ? true : false;
                        columnValue = order.totalNetValue !== null ? order.totalNetValue?.toFixed(2) : "";
                    } else {
                        isDisabled = order.quotedNetValue === null ? true : false;
                        columnValue = order.quotedNetValue !== null ? order.quotedNetValue?.toFixed(2) : "";
                    }
                }
                else if (columnId === "vendorQuotedNetValue") {
                    isDisabled = order.quotedNetValue === null ? true : false;
                    columnValue = order.quotedNetValue !== null ? order.quotedNetValue?.toFixed(2) : "";
                }
                else if (columnId === "customerQuotedNetValue") {
                    isDisabled = order.totalNetValue === null ? true : false;
                    columnValue = order.totalNetValue !== null ? order.totalNetValue?.toFixed(2) : "";
                }
                else if (columnId === "finalNetValue") {
                    columnValue = order.finalNetValue !== null ? order.finalNetValue?.toFixed(2) : "";
                }
            }
            else if (columnDataType === "input") {
                if (columnId === "collectionDate") {
                    isDisabled = order.orderType === "2" ? true : false;
                    columnValueData = { ...column.data };
                    columnValue = order.collectionDate || "";
                    columnValueData.defaultValue = columnValue;
                    columnValueData.disableBeforeDates = [order.createdDate];

                    if ((order.orderType == "2") || (order.orderType == "1" && (userType === 'Vendor' || userType === "ControlTower") && order.status !== 'ORDER_SUBMITTED')) {
                        isDisabled = true;
                    }
                    if ((order.status !== 'ORDER_SUBMITTED') && !order.collectionDate && order.orderType == "1") {
                        isDisabled = false
                        columnValueData.disableAfterDates = new Date();
                    }

                    // Fix for SUPP2-5736 Last Comment By Maria
                    if (userType !== 'ControlTower' && userType !== 'Vendor') {
                        columnValueData = null;
                        columnDataType = "string";
                        columnValue = order.collectionDate || "";
                    }
                }
                if (columnId === "assetsReceiptDate") {
                    columnValueData = { ...column.data };
                    columnValue = order.assetsReceiptDate || "";
                    columnValueData.defaultValue = columnValue;
                    columnValueData.disableAfterDates = new Date();
                    isDisabled = true;
                    columnValueData.disableBeforeDates = [order.collectionDate];

                    if (order.status === 'ASSETS_COLLECTED' && order.collectionDate && order.orderType === "1") {
                        isDisabled = false
                    }
                    if (order.status !== 'ASSETS_COLLECTED' && order.status !== 'ORDER_SUBMITTED' && order.collectionDate && !order.assetsReceiptDate && order.orderType === "1") {
                        isDisabled = false
                    }
                    if (order.status === 'ORDER_SUBMITTED' && order.orderType === '2') {
                        columnValueData.disableBeforeDates = [order.createdDate];
                        isDisabled = false;
                    }
                    if (order.status !== 'ORDER_SUBMITTED' && !order.assetsReceiptDate && order.orderType === '2') {
                        columnValueData.disableBeforeDates = [order.createdDate];
                        isDisabled = false;
                    }
                    if (userType !== 'ControlTower' && userType !== 'Vendor') {
                        columnValueData = null;
                        columnDataType = "string";
                        columnValue = order.assetsReceiptDate || "";
                    }
                }
            }
            else if (columnDataType === "select") {
                if (columnId === "status") {
                    columnValue = getStatusDescriptionFromStatusValue(order.status) || "";
                    columnValueData = { ...column.data };
                    columnValueData.defaultValue = columnValue;
                    columnValueData.options = constructOrderStatusOptions(order.status, order.orderType);

                    // Fix for SUPP2-5736 Last Comment By Maria
                    if (userType !== 'ControlTower' && userType !== 'Vendor') {
                        columnValueData = null;
                        columnDataType = "string";
                        columnValue = getStatusDescriptionFromStatusValue(order.status) || "";
                    }

                    if ((userType !== 'ControlTower' && userType !== 'Vendor') && (order.status === 'ORDER_SENT' || order.status === 'ORDER_RECEIVED')) {
                        columnValue = getStatusDescriptionFromStatusValue("ORDER_SUBMITTED") || "";
                    }
                }
            }

            row.push({
                [columnId]: {
                    id: rowId,
                    columnId: columnId,
                    width: column.width,
                    type: columnDataType,
                    displayAsIs: displayAsIs,
                    disabled: isDisabled,
                    highlightColumn: highlightColumn,
                    value: columnValueData || columnValue,
                    showInMobileViewAs: column.showInMobileViewAs,
                    clickHandler: (columnDataType !== "string" && config.bodyButtonsHandler) ? event => config.bodyButtonsHandler(event, columnId, order.orderId) : null
                }
            });
        });

        tableData.push({
            id: rowId,
            data: row
        });
    })

    result['columns'] = config.columns || [];
    result['data'] = tableData || [];
    return result;
}
